export const QUERY_KEY_MANAGER_PERFORMANCE = {
  MANAGERS: 'MANAGERS',
  MONTHLY_RESULT: 'MONTHLY_RESULT',
  QUARTERLY_RESULT: 'QUARTERLY_RESULT',
  YEARLY_RESULT: 'YEARLY_RESULT',
  CLIENTS_HASHRATE: 'CLIENTS_HASHRATE',
  CLIENTS_COUNT: 'CLIENTS_COUNT',
  MANAGER_HASHRATE_LINE: 'MANAGER_HASHRATE_LINE',
  QUARTERLY_BONUS: 'QUARTERLY_BONUS',
  YEARLY_BONUS_PROGRESS: 'YEARLY_BONUS_PROGRESS',
  MANAGERS_YEARLY_PLAN_LIST: 'MANAGERS_YEARLY_PLAN_LIST',
  TEAM_MONTHLY_GOAL: 'TEAM_MONTHLY_GOAL',
  TEAM_MONTHLY_RESULTS: 'TEAM_MONTHLY_RESULTS',
  TEAM_QUARTERLY_BONUS: 'TEAM_QUARTERLY_BONUS',
  TEAM_QUARTERLY_BONUS_RESULTS: 'TEAM_QUARTERLY_BONUS_RESULTS',
  TEAM_YEARLY_BONUS_RESULTS: 'TEAM_YEARLY_BONUS_RESULTS',
  MANAGERS_SALARY: 'MANAGERS_SALARY',
  MANAGER_MONTHLY_SALARY: 'MANAGER_MONTHLY_SALARY',
  MANAGER_SALARIES: 'MANAGER_SALARIES',
} as const;
